import * as React from "react";

const YellowAccentLines = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            enable-background="new 0 0 780 500"
            version="1.1"
            viewBox="-0.02 0 460.06 208.8"
        >
            {" "}
            <path
                d="M230,166.7c18.4,0,33.3-15.1,33.3-33.8V33.8c0-18.6-14.9-33.8-33.3-33.8s-33.3,15.1-33.3,33.8v99.2c0,18.6,14.9,33.8,33.3,33.8"
                fill="#FFD100"
            ></path>{" "}
            <path
                d="M357.2,203.7c5.5,3.5,11.6,5.1,17.6,5.1,11.1,0,22-5.6,28.3-15.9l51.9-84.1c9.7-15.8,5-36.6-10.6-46.5-15.6-9.9-36.2-5.1-45.9,10.7l-51.9,84.1c-9.8,15.8-5,36.6,10.6,46.5"
                fill="#FFD100"
            ></path>{" "}
            <path
                d="M56.9,192.9c6.3,10.2,17.2,15.9,28.3,15.9s12.1-1.7,17.6-5.1c15.6-9.9,20.3-30.7,10.6-46.5l-51.9-84.1c-9.8-15.8-30.3-20.6-45.9-10.7C0,72.2-4.7,93,5.1,108.8l51.9,84.1Z"
                fill="#FFD100"
            ></path>{" "}
        </svg>
    );
};

export default React.memo(YellowAccentLines);
